import { datadogRum } from "@datadog/browser-rum";

export function setLocalStorageValue(key: string, value: string | object | boolean, action: string) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    window.dispatchEvent(new Event("storage"));
  } catch (err) {
    datadogRum.addError(err, { action, from: "localstorage" });
  }
}

export function getLocalStorageValue<T extends string | object | boolean>(key: string, action: string): T | null {
  try {
    const value = localStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : null;
  } catch (err) {
    datadogRum.addError(err, { action, from: "localstorage" });
    return null;
  }
}

export function removeLocalStorageValue(key: string) {
  localStorage.removeItem(key);
}

export function setSessionStorageValue(key: string, value: string | object | boolean, action: string) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    datadogRum.addError(err, { action, from: "sessionstorage" });
  }
}

export function getSessionStorageValue<T extends string | object | boolean>(key: string, action: string): T | null {
  try {
    const value = sessionStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : null;
  } catch (err) {
    datadogRum.addError(err, { action, from: "sessionstorage" });
    return null;
  }
}
